import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const colorMap = {
  primary: '#6e0ad6',
  secondary: '#4a4a4a',
  white: '#fff',
  darkyellow: '#583F18',
}

const onClickWrapper = props => event => {
  if (props.disabled || (props.onClick && props.preventHrefOnClick)) {
    event.preventDefault()
  }
  if (props.onClick) {
    props.onClick(event)
  }
}

const LINK = props => {
  // removing props from DOM
  const { underline, type, fontWeight, children, disabled, preventHrefOnClick, ...otherProps } =
    props // eslint-disable-line
  if (disabled) {
    otherProps.tabIndex = '-1'
  }

  return (
    <a {...otherProps} onClick={onClickWrapper(props)}>
      {children}
    </a>
  )
}

const link = styled(LINK)`
  color: ${props => colorMap[props.type]};
  font-size: 14px !important;
  font-weight: ${props => props.fontWeight};
  text-align: center !important;
  text-decoration: ${props => (props.underline ? 'underline !important' : 'none !important')};
  ${props => props.underline && 'line-height: 20px !important'}
  font-family: "Nunito Sans", sans-serif !important;
  ${props =>
    props.disabled &&
    `
    opacity: 0.6;
    pointer-events: none;
    cursor: default;
    outline: 0;
  `}
  cursor: pointer;
  ${props => props.fontAdjust}
`

link.propTypes = {
  type: PropTypes.oneOf(['primary', 'secondary', 'white', 'darkyellow']),
  fontWeight: PropTypes.number,
  underline: PropTypes.bool,
  href: PropTypes.string,
  track: PropTypes.string,
  fontAdjust: PropTypes.string,
  target: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  preventHrefOnClick: PropTypes.bool,
}

link.defaultProps = {
  href: '#',
  type: 'secondary',
  fontWeight: 600,
  underline: false,
  disabled: false,
  preventHrefOnClick: true,
}

export default link
